import { animals } from "../data/animals";

export function calculateResult(answers) {
  const scores = {};
  let totalPoints = 0;

  answers.forEach((answer) => {
    if (answer?.scores && typeof answer.scores === "object") {
      Object.entries(answer.scores).forEach(([animalId, point]) => {
        scores[animalId] = (scores[animalId] || 0) + point;
        totalPoints += point;
      });
      return;
    }

    if (answer?.animal) {
      scores[answer.animal] = (scores[answer.animal] || 0) + 1;
      totalPoints += 1;
    }
  });

  const ranked = Object.entries(scores)
    .sort((a, b) => b[1] - a[1])
    .map(([animalId, score]) => ({
      animalId,
      animal: animals[animalId],
      score,
      percent: totalPoints ? Math.round((score / totalPoints) * 100) : 0,
    }));

  const topAnimalId = ranked[0]?.animalId || "owl";
  const topAnimal = animals[topAnimalId];

  return {
    topAnimal,
    totalPoints,
    scores,
    ranked,
  };
}
